var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPodSmallBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.5 5)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.583,
    height: 5.958,
    x: 1.083,
    y: 7.042,
    stroke: "#000",
    rx: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M1.718 0h6.314c.807 0 1.47.64 1.499 1.446l.2 5.62c.01.275-.205.507-.481.517H.518c-.276 0-.5-.224-.5-.5v-.018L.22 1.446C.248.64.911 0 1.72 0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.5 3.25)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.25,
    cy: 3.25,
    r: 3.75,
    fill: "#FFF",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M4.333 2.072c-.056-.054-.15-.054-.207 0l-1.171 1.36-.788-.677c-.057-.054-.114-.054-.17 0l-.33.333c-.056.054-.056.144 0 .198l1.197 1.142c.056.054.15.054.207 0l1.568-1.857c.056-.054.056-.117 0-.171l-.306-.328z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodSmallBlack);
export default __webpack_public_path__ + "static/media/pod-small-black.7a897c60afeee0e8efa0b6294e8405c0.svg";
export { ForwardRef as ReactComponent };